module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_2.e5603dd7.png";